<template>
    <div>
        <div class="modal-body">
            <div class="row gutters">
                <div class="col-12 mb-3">
                    <h6 class="text-center font-weight-bolder" style="color: #0e5e4e">
                        Enviar aos usuários:
                    </h6>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox"
                               v-model="iten.admin"
                               class="custom-control-input" id="admin">
                        <label class="custom-control-label" for="admin">Administradores</label>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox"
                               v-model="iten.gestor"
                               class="custom-control-input" id="gestor">
                        <label class="custom-control-label" for="gestor">Gestores</label>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox"
                               v-model="iten.realtor"
                               class="custom-control-input" id="realtor">
                        <label class="custom-control-label" for="realtor">Corretores</label>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox"
                               v-model="iten.only_active"
                               class="custom-control-input" id="only_active">
                        <label class="custom-control-label" for="only_active">Somente ativos no loteamento</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" @click="sendLink">
                Enviar
            </button>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Allotments from '../../../services/Allotments';

export default {
    name: "modalSendLinkPerson",
    props:['allotmentId'],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data(){
        return{
            iten:{
                realtor: true,
                gestor: true,
                admin: true,
                only_active: false,
            }
        }
    },
    methods:{
        sendLink(){
            if (!this.allotmentId){
                this.toast.error('Selecione um loteamento');
                return;
            }
            this.$store.commit('changeLoading', true);
            let data = {};
            data.only_active = this.iten.only_active
            data.types = [];
            if (this.iten.admin) data.types.push('admin');
            if (this.iten.gestor) data.types.push('gestor');
            if (this.iten.realtor) data.types.push('realtor');
            Allotments.sendLinkClientForUser(this.allotmentId, data).then(() => {
                this.toast.success('Link enviado aos usuários');
                document.getElementById('closeX')?.click();
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        }
    }
}
</script>

<style scoped>

</style>